import type {
  FccCabinSafetyCheckStatus,
  FccWaypointDeliveryActionStatus,
  FccWaypointPickupActionStatus,
} from '@backoffice-frontend/graphql'
import type { VehicleMissionFccUpcomingWaypoint } from '../parseVehicle'
import type {
  VehicleMissionDeliveryActionFragment,
  VehicleMissionPickupActionFragment,
} from '../vehicleMissionCard.hook'

export type Waypoint = Pick<
  VehicleMissionFccUpcomingWaypoint,
  | 'adStateUpdatedAt'
  | 'stop'
  | 'adState'
  | 'actions'
  | 'routeProvider'
  | 'cabinSafetyCheckStatus'
>

export const isTripAction = (action: {
  __typename: string
}): action is
  | VehicleMissionDeliveryActionFragment
  | VehicleMissionPickupActionFragment => {
  return (
    action.__typename === 'FccWaypointDeliveryAction' ||
    action.__typename === 'FccWaypointPickupAction'
  )
}

export type WaypointActionsStatus = {
  deliveryStatus?: FccWaypointDeliveryActionStatus
  pickupStatus?: FccWaypointPickupActionStatus
  cabinSafetyCheckStatus?: FccCabinSafetyCheckStatus
}

export const getActionsStatus = (waypoint: Waypoint): WaypointActionsStatus => {
  const tripActions = waypoint.actions.filter(isTripAction)
  const actionStatus: WaypointActionsStatus = {}

  const deliveryStaus = tripActions.find(
    action => action.__typename === 'FccWaypointDeliveryAction',
  )?.deliveryStatus
  if (deliveryStaus) {
    actionStatus.deliveryStatus = deliveryStaus
  }

  const pickupStatus = tripActions.find(
    action => action.__typename === 'FccWaypointPickupAction',
  )?.pickupStatus
  if (pickupStatus) {
    actionStatus.pickupStatus = pickupStatus
  }

  actionStatus.cabinSafetyCheckStatus =
    waypoint.cabinSafetyCheckStatus ?? undefined

  return actionStatus
}
